import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container product"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = ["data-id"];
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "dialog-footer"
};
import { onMounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { dateFormat, removeArrayItem } from "@/utils/libs";
import { Plus } from "@element-plus/icons-vue";
import { Sortable } from "sortablejs";

// 变量定义

export default {
  __name: 'Product',
  setup(__props) {
    const items = ref([]);
    const item = ref({});
    const showDialog = ref(false);
    const title = ref("");
    const rules = reactive({
      name: [{
        required: true,
        message: '请输入产品名称',
        trigger: 'change'
      }],
      price: [{
        required: true,
        message: '请输产品价格',
        trigger: 'change'
      }],
      discount: [{
        required: true,
        message: '请输优惠金额',
        trigger: 'change'
      }],
      days: [{
        required: true,
        message: '请输入有效期',
        trigger: 'change'
      }]
    });
    const loading = ref(true);
    const formRef = ref(null);

    // 获取数据
    httpGet('/api/admin/product/list').then(res => {
      if (res.data) {
        // 初始化数据
        const arr = res.data;
        for (let i = 0; i < arr.length; i++) {
          arr[i].last_used_at = dateFormat(arr[i].last_used_at);
        }
        items.value = arr;
      }
      loading.value = false;
    }).catch(() => {
      ElMessage.error("获取数据失败");
    });
    onMounted(() => {
      const drawBodyWrapper = document.querySelector('.el-table__body tbody');

      // 初始化拖动排序插件
      Sortable.create(drawBodyWrapper, {
        sort: true,
        animation: 500,
        onEnd({
          newIndex,
          oldIndex,
          from
        }) {
          if (oldIndex === newIndex) {
            return;
          }
          const sortedData = Array.from(from.children).map(row => row.querySelector('.sort').getAttribute('data-id'));
          const ids = [];
          const sorts = [];
          sortedData.forEach((id, index) => {
            ids.push(parseInt(id));
            sorts.push(index + 1);
            items.value[index].sort_num = index + 1;
          });
          httpPost("/admin/product/sort", {
            ids: ids,
            sorts: sorts
          }).catch(e => {
            ElMessage.error("排序失败：" + e.message);
          });
        }
      });
    });
    const add = function () {
      title.value = "新增产品";
      showDialog.value = true;
      item.value = {};
    };
    const edit = function (row) {
      title.value = "修改产品";
      showDialog.value = true;
      item.value = row;
    };
    const save = function () {
      formRef.value.validate(valid => {
        if (valid) {
          showDialog.value = false;
          item.value['price'] = parseFloat(item.value['price']);
          item.value['discount'] = parseFloat(item.value['discount']);
          httpPost('/api/admin/product/save', item.value).then(res => {
            ElMessage.success('操作成功！');
            if (!item.value['id']) {
              const newItem = res.data;
              items.value.push(newItem);
            }
          }).catch(e => {
            ElMessage.error('操作失败，' + e.message);
          });
        } else {
          return false;
        }
      });
    };
    const enable = row => {
      httpPost('/api/admin/product/enable', {
        id: row.id,
        enabled: row.enabled
      }).then(() => {
        ElMessage.success("操作成功！");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };
    const remove = function (row) {
      httpGet('/api/admin/product/remove?id=' + row.id).then(() => {
        ElMessage.success("删除成功！");
        items.value = removeArrayItem(items.value, row, (v1, v2) => {
          return v1.id === v2.id;
        });
      }).catch(e => {
        ElMessage.error("删除失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: add
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("新增")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "产品名称"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", {
              class: "sort",
              "data-id": scope.row.id
            }, [_cache[9] || (_cache[9] = _createElementVNode("i", {
              class: "iconfont icon-drag"
            }, null, -1)), _createTextVNode(" " + _toDisplayString(scope.row.name), 1)], 8, _hoisted_3)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "price",
            label: "商品原价"
          }), _createVNode(_component_el_table_column, {
            prop: "discount",
            label: "优惠价"
          }), _createVNode(_component_el_table_column, {
            prop: "days",
            label: "有效期(天)"
          }, {
            default: _withCtx(scope => [scope.row.days === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("长期有效")])),
              _: 1
            })) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(scope.row.days), 1))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "power",
            label: "算力"
          }), _createVNode(_component_el_table_column, {
            prop: "sales",
            label: "销量"
          }), _createVNode(_component_el_table_column, {
            prop: "enabled",
            label: "启用状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row['enabled'],
              "onUpdate:modelValue": $event => scope.row['enabled'] = $event,
              onChange: $event => enable(scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "更新时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row['updated_at'])), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "180"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => edit(scope.row)
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("编辑")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
              title: "确定要删除当前记录吗?",
              onConfirm: $event => remove(scope.row),
              width: 200
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data", "row-key"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showDialog.value = $event),
        title: title.value,
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("提交")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: item.value,
          "label-width": "120px",
          ref_key: "formRef",
          ref: formRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "商品名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => item.value.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商品原价：",
            prop: "price"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.price,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => item.value.price = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "优惠价：",
            prop: "discount"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.discount,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => item.value.discount = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "有效期：",
            prop: "days"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.days,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => item.value.days = $event),
              modelModifiers: {
                number: true
              },
              autocomplete: "off",
              placeholder: "会员有效期(天)"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "算力：",
            prop: "power"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: item.value.power,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => item.value.power = $event),
              modelModifiers: {
                number: true
              },
              autocomplete: "off",
              placeholder: "增加算力值"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "启用状态：",
            prop: "enable"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: item.value.enabled,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => item.value.enabled = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])])), [[_directive_loading, loading.value]]);
    };
  }
};